(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-hero"] && !Shopify.designMode) return;
  try {
    
  class UJHero {
    constructor(container) {
      this.container = container;
      this.viewport = container.querySelector('.uj-hero-viewport');
      this.slides = Array.from(container.querySelectorAll('.uj-slide'));
      this.totalSlides = this.slides.length;
      
      // CONFIGURATION
      this.settings = {
        lerpFactor: 0.08, // The lower this is, the "heavier" the scroll feels (0.05 - 0.1 is luxury range)
        parallaxText: 100, // Pixels the text moves during transition
      };

      // STATE
      this.state = {
        targetY: 0,    // Where the scrollbar actually is
        currentY: 0,   // Where our animation is (interpolated)
        isDesktop: false,
        headerHeight: 0
      };

      // BINDINGS
      this.tick = this.tick.bind(this);
      this.onResize = this.onResize.bind(this);
      
      this.init();
    }

    init() {
      // 1. Initial Measurement
      this.checkEnvironment();
      
      // 2. Loop
      window.requestAnimationFrame(this.tick);
      
      // 3. Events
      window.addEventListener('resize', this.onResize);
    }

    checkEnvironment() {
      this.state.isDesktop = window.matchMedia('(min-width: 750px)').matches;
      
      // Dawn Header Height Calculation
      const header = document.querySelector('.header-wrapper');
      if (header) {
        this.state.headerHeight = header.getBoundingClientRect().height;
        this.container.style.setProperty('--header-offset', `${this.state.headerHeight}px`);
      }
    }

    onResize() {
      this.checkEnvironment();
    }

    // MATH UTILS
    lerp(start, end, t) {
      return start * (1 - t) + end * t;
    }
    
    easeOutExpo(x) {
      return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
    }

    tick() {
      // KEEP LOOP RUNNING
      window.requestAnimationFrame(this.tick);
      
      if (!this.state.isDesktop) return;

      // 1. READ SCROLL
      // Where is the top of the track relative to the viewport top?
      // Subtract header offset so '0' is exactly when sticky starts.
      const rect = this.container.getBoundingClientRect();
      const rawScroll = -rect.top + this.state.headerHeight;

      // 2. INTERPOLATE (The "Heavy" Feel)
      this.state.targetY = rawScroll;
      
      // Stop jitter at small deltas
      if (Math.abs(this.state.targetY - this.state.currentY) < 0.1) {
        this.state.currentY = this.state.targetY;
      } else {
        this.state.currentY = this.lerp(this.state.currentY, this.state.targetY, this.settings.lerpFactor);
      }

      // 3. CALCULATE PROGRESS
      const viewportHeight = window.innerHeight;
      
      // Global Progress: 0 = Start of Slide 1, 1 = Start of Slide 2
      let globalProgress = this.state.currentY / viewportHeight;
      
      // Clamp logic
      if (globalProgress < 0) globalProgress = 0;
      if (globalProgress > this.totalSlides - 0.01) globalProgress = this.totalSlides - 0.01;

      // 4. ANIMATE SLIDES
      const currentIndex = Math.floor(globalProgress);
      const localProgress = globalProgress - currentIndex; // 0.0 -> 1.0

      this.slides.forEach((slide, index) => {
        const media = slide.querySelector('.uj-media');
        const content = slide.querySelector('.uj-content-inner');
        
        const scaleStart = parseFloat(slide.dataset.scaleStart) || 1.1;
        const scaleEnd = parseFloat(slide.dataset.scaleEnd) || 1.0;
        
        // Reset Defaults
        slide.style.visibility = 'hidden';
        slide.style.opacity = 0;
        slide.style.zIndex = 0;
        
        // --- LOGIC: THE CURTAIN ---
        
        // SCENARIO A: The "Base" Slide (The one being covered)
        if (index === currentIndex) {
          slide.style.visibility = 'visible';
          slide.style.opacity = 1; 
          slide.style.zIndex = 1; 
          
          // It stays at 100% opacity, but maybe scales slightly as it waits?
          // Let's keep it static scaleEnd to be the "floor"
          media.style.transform = `scale(${scaleEnd})`;
          content.style.opacity = 1;
          content.style.transform = `translateY(0px)`;
        }
        
        // SCENARIO B: The "Incoming" Slide (The one covering)
        else if (index === currentIndex + 1) {
          slide.style.visibility = 'visible';
          slide.style.zIndex = 5; // Top Layer
          
          // Easing for the visual transition
          const eased = this.easeOutExpo(localProgress);
          
          slide.style.opacity = eased; 
          
          // Scale from Start -> End
          const currentScale = this.lerp(scaleStart, scaleEnd, eased);
          media.style.transform = `scale(${currentScale})`;
          
          // Text Parallax (Coming up from bottom)
          const textY = (1 - eased) * 40; // Moves up 40px
          content.style.opacity = eased;
          content.style.transform = `translateY(${textY}px)`;
        }
        
        // SCENARIO C: Just in case of fast scroll (Previous slides)
        else if (index < currentIndex) {
           // Fully done slides (behind the scenes)
           slide.style.zIndex = 0;
           media.style.transform = `scale(${scaleEnd})`;
        }
      });
    }
  }

  // Init
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.uj-hero-track');
    if (section) new UJHero(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll("[data-watch-faq]").forEach(function (root) {
      function openItem(q, open) {
        q.setAttribute("aria-expanded", String(open));
        var a = q.parentElement.querySelector(".watch-faq__a");
        var inner = a.querySelector(".watch-faq__a-inner");
        a.style.maxHeight = open ? inner.scrollHeight + "px" : null;
      }

      function openFirstQuestion(panel) {
        // close every question in this panel, then open the first
        panel.querySelectorAll(".watch-faq__q").forEach(function (q) {
          q.setAttribute("aria-expanded", "false");
        });
        panel.querySelectorAll(".watch-faq__a").forEach(function (a) {
          a.style.maxHeight = null;
        });
        var firstQ = panel.querySelector(".watch-faq__q");
        if (firstQ) openItem(firstQ, true);
      }

      // Desktop: side-nav switches which panel is visible
      root.querySelectorAll("[data-faq-cat]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var idx = btn.getAttribute("data-faq-cat");
          root.querySelectorAll("[data-faq-cat]").forEach(function (b) {
            b.classList.toggle("is-active", b === btn);
          });
          root.querySelectorAll("[data-faq-panel]").forEach(function (p) {
            var on = p.getAttribute("data-faq-panel") === idx;
            p.classList.toggle("is-active", on);
            if (on) openFirstQuestion(p);
          });
        });
      });

      // Mobile: each category header is itself an accordion (single-open)
      root.querySelectorAll(".watch-faq__panel-head").forEach(function (head) {
        head.addEventListener("click", function () {
          var panel = head.closest(".watch-faq__panel");
          var wasOpen = panel.classList.contains("is-open");
          root.querySelectorAll(".watch-faq__panel").forEach(function (p) {
            p.classList.remove("is-open");
            var h = p.querySelector(".watch-faq__panel-head");
            if (h) h.setAttribute("aria-expanded", "false");
          });
          if (!wasOpen) {
            panel.classList.add("is-open");
            head.setAttribute("aria-expanded", "true");
            openFirstQuestion(panel);
          }
        });
      });

      // Question accordions
      root.querySelectorAll(".watch-faq__q").forEach(function (q) {
        q.addEventListener("click", function () {
          openItem(q, q.getAttribute("aria-expanded") !== "true");
        });
      });

      // Open the first question of the default-open category on load
      var activePanel =
        root.querySelector(".watch-faq__panel.is-active") ||
        root.querySelector(".watch-faq__panel");
      if (activePanel) {
        var firstQ = activePanel.querySelector(".watch-faq__q");
        if (firstQ) openItem(firstQ, true);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
